module.exports = __webpack_public_path__ + "img/27.ba81744.png";